enum TryItOutAuthMode {
  NONE = 'NONE',
  COOKIE = 'COOKIE',
}

export default TryItOutAuthMode;
